<template>
  <div class="header">
    <div class="logo" @click="navBack"><img src="../assets/images/logo.svg" width="240" alt="logo"></div>
    <div class="navs">
      <!-- <a class="nav-item active" href="/#/">首页</a> -->
      <a class="nav-item" href="https://td-zhgz-dzgzs.oss-cn-shanghai.aliyuncs.com/HashCalculate-1.1.0.exe" download>工具下载</a>
      <!-- <a class="nav-item" href="/#">帮助中心</a>
      <a class="nav-item" href="/#">接入指南</a> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "Header",
  methods: {
    navBack() {
      this.$router.push("/");
    }
  }
};
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 0;
  height: 48px;
  .logo {
    cursor: pointer;
  }

  .nav-item {
    cursor: pointer;
    text-decoration: none;
    color: #383838;
    transition: all 0.5s;
    &.active,
    &:hover {
      color: #4d6de3;
    }
    & + .nav-item {
      margin-left: 32px;
    }
  }
}
</style>